export interface FindModelProduct {
  categoryId: string;
  categoryName: string;
  [key: string]: unknown;
}

export interface FindModelCategory {
  superCategoryId: string;
  superCategoryName: string;
  categoryList: FindModelProduct[];
  [key: string]: unknown;
}

export interface FindModelGuide {
  modelImagePathName?: string;
  normalizedModelImagePathName?: string;
  modelImageAltName?: string;
  modelNumberDesc?: string;
  [key: string]: unknown;
}

// agent /api/find-model-* 프록시는 인증키 불요 (agent 가 서버측에서 NCMS 호출).
const API_BASE = import.meta.env.VITE_FIND_MODEL_API_BASE || "";

function requestHeaders(sessionToken: string): Record<string, string> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (sessionToken) {
    headers["Mcp-Session-Id"] = sessionToken;
  }
  return headers;
}

function unwrap<T>(body: unknown, topLevelKey: string): T {
  const obj = (body || {}) as Record<string, unknown>;
  const data = (obj.data || {}) as Record<string, unknown>;
  return (obj[topLevelKey] || data[topLevelKey] || []) as T;
}

export async function fetchFindModelCategories(
  locale: string,
  sessionToken: string,
): Promise<FindModelCategory[]> {
  const res = await fetch(`${API_BASE}/api/find-model-category?locale=${encodeURIComponent(locale)}`, {
    method: "POST",
    headers: requestHeaders(sessionToken),
    body: JSON.stringify({}),
    credentials: "include",
  });
  if (!res.ok) {
    throw new Error(`find-model category failed: ${res.status}`);
  }
  return unwrap<FindModelCategory[]>(await res.json(), "retrieveFindMyModelCategory");
}

export async function fetchFindModelNumber(
  locale: string,
  superCategoryId: string,
  categoryId: string,
  sessionToken: string,
): Promise<FindModelGuide | null> {
  const res = await fetch(`${API_BASE}/api/find-model-number?locale=${encodeURIComponent(locale)}`, {
    method: "POST",
    headers: requestHeaders(sessionToken),
    body: JSON.stringify({ findType: "SN", superCategoryId, categoryId }),
    credentials: "include",
  });
  if (!res.ok) {
    throw new Error(`find-model number failed: ${res.status}`);
  }
  return unwrap<FindModelGuide | null>(await res.json(), "findModel");
}

export function findModelImageUrl(path?: string, locale = "UK"): string {
  const raw = (path || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const legacyFindModelPath = raw.match(/^\/([a-z]{2}(?:_[a-z]{2})?)\/images\/find-my-model\/(.+)$/i);
  if (legacyFindModelPath) {
    return `https://www.lg.com/content/dam/channel/wcms/${legacyFindModelPath[1].toLowerCase()}/images/find-my-model/${legacyFindModelPath[2]}`;
  }
  if (raw.startsWith("/")) return `https://www.lg.com${raw}`;
  const market = (locale || "UK").toLowerCase();
  return `https://www.lg.com/content/dam/channel/wcms/${market}/images/find-my-model/${raw}`;
}
